import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { Topic } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './Functions.grid'
import { getProperties } from './Functions.properties'

export default function Functions({
  topics,
  drillUrl,
}: {
  topics: Topic[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(30,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(14,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(16,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={2400} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          height={1131}
          image="math-drills/functions/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.functionsBeanStalkTablet')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-36 -left-6 w-[1000px]"
          height={1440}
          image="math-drills/functions/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.functionsBeanStalkDesktop')}
        />
      </div>
      <DrillTopicGridLayout className={`mb-8 ${[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}`}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
